<ng-container *ngIf="trackingState$ | async as trackingState">
  <div class="container">
    <div class="tracking">
      <div class="d-flex align-items-center justify-content-center">
        <ng-container *ngIf="trackingState.loading; else resultTemplate">
          <div class="tracking-card">
            <div class="tracking-card-header">
              <h1>Статусы заказа</h1>
              <p class="tracking-card-header-planned-date">
                Время доставки
                <span class="skeleton"></span>
              </p>
            </div>
            <div class="tracking-card-body">
              <ul class="tracking-statuses">
                <ng-container *ngFor="let i of [].constructor(3)">
                  <li>
                    <span class="skeleton"></span>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </ng-container>

        <ng-template #resultTemplate>
          <ng-container *ngIf="trackingState.success && trackingState.value; else errorTemplate">
            <ng-container *ngIf="trackingState.value as tracking">
              <div class="tracking-card">
                <div class="tracking-card-header">
                  <h1>Статусы заказа</h1>
                  <p class="tracking-card-header-planned-date">
                    Время доставки
                    <span class="tracking-card-header-planned-date-value">
                      {{ { from: tracking.plannedDeliveryFrom, to: tracking.plannedDeliveryTo } | dateInterval }}
                    </span>
                  </p>
                </div>
                <div class="tracking-card-body">
                  <ul class="tracking-statuses">
                    <ng-container *ngFor="let status of tracking.statuses">
                      <li [ngClass]="{ finished: !!status.datetimeAt }">
                        {{ status.title }}
                        <div class="date-at" *ngIf="status.datetimeAt">
                          {{ status.datetimeAt | date: 'd MMMM HH:mm' }}
                        </div>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </ng-template>

        <ng-template #errorTemplate>
          <div class="error">
            <h1>Информация о доставке не найдена</h1>
            <p>Обратитесь в колл-центр</p>
            <a href="tel:88003337719" class="btn">
              <img src="assets/images/tracking/phone-icon.svg" />

              8 800 333 77 19
            </a>
          </div>
        </ng-template>
      </div>

      <div class="buttons">
        <a
          sdButton
          [fullWidth]="true"
          type="accent"
          [routerLink]="{ cxRoute: 'category', params: { code: 'stroitelnye-materialy-5521' } } | cxUrl"
        >
          В каталог
        </a>
        <a sdButton [fullWidth]="true" type="accent" [routerLink]="{ cxRoute: 'orders' } | cxUrl">В личный кабинет</a>
      </div>
    </div>
  </div>
</ng-container>
